import { useStaticQuery, graphql } from "gatsby"

export const useFooterData = () => {
  const wordpress = useStaticQuery(graphql`query GetFooterData {
  wp {
    footerOptions {
      footerAssociationLogos {
        logos {
          description
          altText
          title
          sourceUrl
          localFile {
            childImageSharp {
              gatsbyImageData(width: 180, layout: CONSTRAINED)
            }
          }
        }
      }
    }
  }
}
`)

  return wordpress.wp.footerOptions.footerAssociationLogos.logos
}
